module.exports={
	"Form": "RoleViewManifest",
	"Scope": "Role-View",
	"Descriptors":
	{
		"RoleDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RoleView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.GUIDRole":
		{
			"Name": "GUID",
			"Hash": "RoleView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.Name":
		{
			"Name": "Role Name",
			"Hash": "RoleView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RoleIdentity",
				"Group": "RoleIdentity"
			}
		},
		"RoleDetails.Description":
		{
			"Name": "Description",
			"Hash": "RoleView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.PermissionLevel":
		{
			"Name": "Permission Level",
			"Hash": "RoleView-PermissionLevel",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.Type":
		{
			"Name": "Role Type",
			"Hash": "RoleView-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.LinkedIDUser":
		{
			"Name": "Linked User ID",
			"Hash": "RoleView-LinkedIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "RoleConfig",
				"Group": "RoleConfig"
			}
		},
		"RoleDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RoleView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "RoleView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RoleView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		},
		"RoleDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "RoleView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "RoleAudit",
				"Group": "RoleAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RoleIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RoleIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RoleConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RoleConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RoleAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RoleAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
